import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Stack from 'react-bootstrap/Stack';

const propTypes = {
  schedules: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
      group: PropTypes.string,
    })
  ),
  setSchedule: PropTypes.func.isRequired,
  isActive: PropTypes.func.isRequired,
};

export default function scheduleSelection(props: InferProps<typeof propTypes>): JSX.Element {
  const { schedules, setSchedule, isActive } = props;

  const groupedMap = schedules.reduce(
    (entryMap, e) => entryMap.set(e.group, [...entryMap.get(e.group) || [], e]),
    new Map()
  );
  const groupedArray = Array.from(groupedMap.values());

  return (
    <>
      <h3 className='schedule-subheading'>Please select a schedule</h3>
      <Stack>
        {groupedArray.map((obj, index) => (
          <div className='schedule-group' key={`schedule_group_container_${index}`}>
            <h3 className='schedule-group--title'>{obj[0].group}</h3> {/* TODO This needs to change, accessing the first element of the array like this is frail */}
            <ButtonGroup className='schedule-btn-group'>
              {obj.map((el: object, index: number) => (
                <Button
                  name={el.name}
                  variant="outline-primary"
                  type="button"
                  className="themed-btn--secondary schedule-btn"
                  onClick={() => setSchedule(el.id)}
                  active={isActive(el.id)}
                  key={el.name}
                >
                  {el.name}
                </Button>
              ))}
            </ButtonGroup>
          </div>
        ))}
      </Stack>
    </>
  )
}
